module.exports = __webpack_public_path__ + "static/media/iit.d506b1d5.png";